module.exports = __webpack_public_path__ + "img/mw.6073ddcf.svg";